import RequestState from 'Enums/RequestState'
import { createReducer } from 'reduxsauce'
import { CountriesTypes } from './Actions'
import { INITIAL_STATE } from './initialState'
import IFFilterType from 'Enums/IFFilterType'

export const fetchCountriesListCountLoading = (state) => {
  return {
    ...state,
    fetchCountriesListCountRequestState: RequestState.LOADING,
  }
}
export const fetchCountriesListCountSuccess = (state, { countriesCount }) => {
  return {
    ...state,
    countriesCount: countriesCount,
    fetchCountriesListCountRequestState: RequestState.SUCCEEDED,
  }
}
export const fetchCountriesListCountFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchCountriesListCountRequestState: requestState,
  }
}
export const fetchCountriesListLoading = (state) => {
  return {
    ...state,
    fetchCountriesRequestState: RequestState.LOADING,
  }
}

export const fetchCountriesListSuccess = (
  state,
  { offset, countries, nextOffset },
) => {
  if (offset === 0) {
    return {
      ...state,
      fetchCountriesRequestState: RequestState.SUCCEEDED,
      countriesPaginationOffset: nextOffset,
      countries: [...countries],
    }
  } else {
    return {
      ...state,
      fetchCountriesRequestState: RequestState.SUCCEEDED,
      countriesPaginationOffset: nextOffset,
      countries: [...state.countries, ...countries],
    }
  }
}

export const fetchCountriesListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchCountriesRequestState: requestState,
  }
}

export const setCountriesFilter = (state, { newFilter }) => {
  return {
    ...state,
    countriesFilters: newFilter,
  }
}
export const clearCountriesFilter = (state) => {
  let countriesFilters = JSON.parse(
    JSON.stringify(INITIAL_STATE.countriesFilters),
  )
  return {
    ...state,
    countriesFilters: [...countriesFilters],
  }
}
export const clearCountries = (state) => {
  return {
    ...state,
    countries: [],
    countriesPaginationOffset: 0,
    fetchCountriesRequestState: RequestState.UNINITIALIZED,
  }
}
export const addCountrySuccess = (state, { country }) => {
  return {
    ...state,
    countries: [country, ...state.countries],
    countriesCount: state.countriesCount + 1,
    addCountryRequestState: RequestState.SUCCEEDED,
  }
}

export const addCountryLoading = (state) => {
  return {
    ...state,
    addCountryRequestState: RequestState.LOADING,
  }
}

export const addCountryFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    addCountryRequestState: requestState,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [CountriesTypes.FETCH_COUNTRIES_LIST_COUNT_LOADING]:
    fetchCountriesListCountLoading,
  [CountriesTypes.FETCH_COUNTRIES_LIST_COUNT_SUCCESS]:
    fetchCountriesListCountSuccess,
  [CountriesTypes.FETCH_COUNTRIES_LIST_COUNT_FAIL]: fetchCountriesListCountFail,
  [CountriesTypes.FETCH_COUNTRIES_LIST_LOADING]: fetchCountriesListLoading,
  [CountriesTypes.FETCH_COUNTRIES_LIST_SUCCESS]: fetchCountriesListSuccess,
  [CountriesTypes.FETCH_COUNTRIES_LIST_FAIL]: fetchCountriesListFail,
  [CountriesTypes.SET_COUNTRIES_FILTER]: setCountriesFilter,
  [CountriesTypes.CLEAR_COUNTRIES_FILTER]: clearCountriesFilter,
  [CountriesTypes.CLEAR_COUNTRIES]: clearCountries,
  [CountriesTypes.ADD_COUNTRY_SUCCESS]: addCountrySuccess,
  [CountriesTypes.ADD_COUNTRY_LOADING]: addCountryLoading,
  [CountriesTypes.ADD_COUNTRY_FAIL]: addCountryFail,
})
